import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import Sidebar from './Sidebar'; // Student
import Sidebar2 from './Sidebar2'; // Admin
import Sidebar3 from './Sidebar3'; // Instructor
import AuthContext from '../services/AuthContext';

import PersistentAlert from './PersistentAlert';

const SIDEBAR_WIDTH = '70px';

const ResponsiveLayout = ({ children }) => {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const isMobile = useBreakpointValue({ base: true, md: false });

    // Completely bypass ResponsiveLayout inside meeting rooms
    if (location.pathname.toLowerCase().startsWith('/meet')) {
        return <>{children}</>;
    }

    // Only show sidebars for authenticated users with roles
    if (!user || !user.role) {
        return <Box minH="100vh">{children}</Box>;
    }

    const getSidebar = () => {
        switch (user.role) {
            case 'admin': return <Sidebar2 />;
            case 'instructor': return <Sidebar3 />;
            case 'student': return <Sidebar />;
            default: return null;
        }
    };

    return (
        <Box dir="rtl" minH="100vh" bg="#f8fafc">
            <Flex minH="100vh">
                {getSidebar()}
                <Box
                    flex="1"
                    p={{ base: 4, md: 8 }}
                    mr={isMobile ? '0px' : SIDEBAR_WIDTH}
                    transition="margin-right 0.3s ease"
                    w="full"
                    maxW="100%"
                    overflowX="auto"
                >
                    <Box maxW="1600px" mx="auto">
                        <PersistentAlert />
                        {children}
                    </Box>
                </Box>
            </Flex>
        </Box>
    );
};

export default ResponsiveLayout;
